<template>
  <div>
    <project-list v-show="tabType === 1" @handleShow="handleShow" />
    <project-show v-if="tabType === 2" :rowItem="rowItem"  @handleShow="handleShow" />
  </div>
</template>

<script>
import projectList from './list.vue'
import projectShow from './show.vue'
export default {
  components: { projectList, projectShow },
  data() {
    return {
      tabType: 1,
      rowItem: null
    }
  },
  methods: {
    handleShow(row, type) {
      this.rowItem = { ...row }
      this.tabType = type
    }
  }
}
</script>

<style>
</style>